// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NCnAx","col":"styles_col__BvZHa"};